import { DatePipe } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { DEFAULT_DATE_FORMAT } from '@app/shared/configs/date-format.config';
import { LanguageService } from '@app/shared/services/shared/language.service';

/**
 * DateFormatService - locale-aware date formatting via Angular DatePipe.
 *
 * Scope: Global (`providedIn: 'root'`).
 *
 * Usage: TypeScript formatters (dropdown labels, table renderers, exports display) that cannot use {@link ProffeoDatePipe}.
 */
@Injectable({ providedIn: 'root' })
export class DateFormatService {
  private readonly datePipe = inject(DatePipe);
  private readonly languageService = inject(LanguageService);

  public format(
    value: Date | string | number | null | undefined,
    format: string = DEFAULT_DATE_FORMAT,
    timezone?: string
  ): string {
    if (value == null || value === '') {
      return '';
    }

    return this.datePipe.transform(value, format, timezone, this.languageService.currentLocale()) ?? '';
  }
}
